import MyProfileIcon from 'assets/svgr-icons/my-profile.svg'
import QuestionIcon from 'assets/svgr-icons/question-mark.svg'
import { T } from 'consts/translationKeys'
import { getUrl } from 'utils'
import { translate } from 'utils/translations'
import { IListItemData } from '../ListItem/types'

export const listItemsData: IListItemData[] = [
  {
    id: 'my-account',
    icon: MyProfileIcon,
    label: translate(T.MY_ACCOUNT_LABEL),
    url: getUrl('/profile/account')
  },
  {
    id: 'help-and-support',
    icon: QuestionIcon,
    label: translate(T.HELP_AND_SUPPORT_LABEL),
    url: getUrl('/help-and-support')
  }
]
